export const useYoutickets = () => ({
  head: [
    {
      dataField: 'name',
      label: '',
    },
    {
      dataField: 'fullPrice',
      label: 'Preț',
    },
    {
      dataField: "discount",
      label: 'Early Bird',
    },
    {
      dataField: 'buyTicket',
      label: '',
    },
  ],
  data: [
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Conference Pass: YouImagine'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '490 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '390 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Ioan Braghesiu'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1050 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '800 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Vlad Eftenie'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '450 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '300 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Cătălin Muntean'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1300 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '990 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Sorin Onișor'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '700 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '500 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Daniela Sterea'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '700 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '500 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
  ]
});